import { Component } from 'react'
import { graphql, compose } from 'react-apollo'

import { $ } from 'utils'
import { Loader } from 'components'
import { IDENTIFY_FACE } from 'queries/matching'
import { withConsumer } from 'store'

import Results from './Results'

class IdentifyFace extends Component {

  render() {
    const { closeBottomPanel, type, matchType, data: { loading, identify, error, descriptor } } = this.props
    if (loading) return $(Loader)

    return (
      $(Results, { closeBottomPanel, type, matchType, results: identify, source: descriptor, loading, error })
    )
  }
}

export default compose(
  graphql(IDENTIFY_FACE, {
    options: props => ({
      variables: {
        fetchPolicy: 'cache-and-network',
        descriptorId: props.descriptorId,
        limit: +props.limit,
        listId: props.listId,
        personIds: props.personIds,
      }
    })
  })
)(withConsumer(IdentifyFace, '/faces'))




// WEBPACK FOOTER //
// ./src/components/panels/MatchingResults/IdentifyFace.js